<template>
    <Drawer v-model:visible="visible" position="right" id="easyPopupFindProfile">
        <template #header>
            <div class="flex items-center gap-2">
                <Avatar :image="$utils.getAvatar(target_user.avatar)" shape="circle" />
                <span class="font-bold">{{ target_user.nickname }}</span>
            </div>
        </template>

        <ProfileCard :profile="target_user"></ProfileCard>
        <template #footer>
            <div class="flex items-center gap-2">
                <Button :label="$t('profile_card.sendGift')" icon="pi pi-gift" class="flex-auto" severity="warn" plain
                    text @click="sendGift()"></Button>
                <Button :label="$t('profile_card.sendMessage')" icon="pi pi-send" class="flex-auto" plain text
                    @click="sendMesssage()"></Button>
            </div>
        </template>
    </Drawer>
</template>

<script>
import ProfileCard from '../chat_parts/ProfileCard.vue';

export default {
    name: "LookProfile",
    components: {
        ProfileCard,
    },
    data() {
        return {
            visible: false,
            target_user: null
        }
    },
    methods: {

        sendMesssage() {
            this.visible = false;
            const user = this.target_user;
            this.$emit('selectMenu', { action: 'message', user: { user_id: user.user_id, nickname: user.nickname, avatar: user.avatar } });
        },
        sendGift() {
            this.visible = false;
            const user = this.target_user;
            this.$emit('selectMenu', { action: 'gift', user: { user_id: user.user_id, nickname: user.nickname, avatar: user.avatar } });
        },

        showProfile(user) {
            this.target_user = { ...user, };
            this.visible = true
            if (user.id)
            this.$socket.emit('getFullProfile', user.id);
            else if (user.user_id)
            this.$socket.emit('getFullProfile', user.user_id);
        }
    },
    mounted() {
        this.$socket.on('user_info_full', (data) => {
            if (!data)
                return;
            for (const property in data) {
                if (property == 'avatar' && !this.target_user[property]) {
                    this.target_user[property] = this.target_user.avatar;
                    continue;
                }
                this.target_user[property] = data[property];
            }
            if (typeof data.age == 'number' )
            this.target_user.age = data.age;
        });
    }
}
</script>